import React, { useState } from "react"
import Layout from "../../../components/layouts/layout"
import PropTypes from "prop-types"
import validation from "../validation"
import { Modal } from "react-bootstrap"
import { navigate } from "gatsby"
import LogoGreen from "../../../../static/images/images/logo-green.svg"
import image1 from "../../../../static/images/logo.svg"
import close from "../../../../static/images/close.svg"
import InsuranceEligibilty from "pages/welcomevisits/insuranceEligibility"
import { trackFormSubmitSuccess } from "../../../utils/analytics"
import { InsuranceOptionDropdown } from "./insuranceOptionDropdown"
import ContinueButton from "components/elements/styledButton/ContinueButton"
import moment from "moment"
import { StartScheduling } from "./startScheduling"
import ProgressBar from "utils/stepper"
import MorningApptBanner from "utils/morningApptBanner"

const SelfPlay = ({
  apiData,
  prevStep,
  setFunction,
  setOpenSlotsResults,
  setUser,
  user,
}) => {
  const [errField, setErrField] = useState({
    plan_nameErr: "",
  })
  const handleChange = e => {
    validation.validateInsurancePlanOnChange(e, setErrField, setUser, user)
  }
  const handleSubmit = () => {
    navigate("/")
  }
  const [showStartSched, setShowStartSched] = useState(false)
  const [errorSales, setErrorSales] = useState(false)
  const [show, setShow] = useState(false)
  const apiCall = async () => {
    setShoww(true)
    try {
      var raw = JSON.stringify({
        first_name_axon: apiData.user.name,
        last_name_axon: apiData.user.lastName,
        seeking_diagnoses_axon: JSON.parse(
          apiData.pationinfo.seeking_diagnoses
        ),
        seeking_evalutation_axon: JSON.parse(
          apiData.pationinfo.seeking_evaluation
        ),
        previously_diagnosed_axon: JSON.parse(
          apiData.pationinfo.previously_diagnosed
        ),
        date_of_birth_axon: apiData.user.birthdate,
        clinic_name_axon: apiData.findAFacilityuser.findAFacility,
        address_axon: apiData.user.address1,
        address2_axon: apiData.user.address2,
        city_axon: apiData.user.city,
        state_axon: apiData.user.state,
        zip_axon: apiData.user.zipCode,
        gender_axon: apiData.user.gender,
        caregivers: [
          {
            first_name_axon: apiData.careuser.name,
            last_name_axon: apiData.careuser.lastName,
            email_axon: apiData.careuser.emailAddress,
            phone_axon: apiData.careuser.phoneNumber,
            isValidPhoneNumber_axon: apiData.careuser.isValidPhoneNumber,
            address_axon: apiData.careuser.address1,
            address2_axon: apiData.careuser.address2,
            city_axon: apiData.careuser.city,
            state_axon: apiData.careuser.state,
            zip_axon: apiData.careuser.zipCode,
            is_primary_axon: JSON.parse(apiData.careuser.primary_caregiver),
            is_legal_guardian_axon: JSON.parse(apiData.careinfo.legal_guardian),
            is_emergency_contact_axon: JSON.parse(
              apiData.careinfo.emergency_contact
            ),
            caregiver_relationship_axon: apiData.careinfo.careinformation,
          },
        ],
        guarantor_first_name_axon: apiData.insuranceuser.name,
        guarantor_last_name_axon: apiData.insuranceuser.lastName,
        guarantor_email_axon: apiData.insuranceuser.emailAddress,
        guarantor_phone_axon: apiData.insuranceuser.phoneNumber,
        guarantor_address_axon: apiData.insuranceuser.address1,
        guarantor_address2_axon: apiData.insuranceuser.address2,
        guarantor_city_axon: apiData.insuranceuser.city,
        guarantor_state_axon: apiData.insuranceuser.state,
        guarantor_zip_axon: apiData.insuranceuser.zipCode,
        member_number_axon: apiData.insuranceplan.member_number,
        group_number_axon: apiData.insuranceplan.group_number,
        insurance_name_axon: "Self-Pay",
        insurance_plan_axon: "Self Pay",
        insurance_phone_axon: apiData.insuranceplan.insurance_phone,
        isValidInsurancePhone_axon: apiData.insuranceuser.isValidPhoneNumber,
        plan_coverage_axon: apiData.insuranceplan.plan_name,
        lead_source_axon: apiData.findAFacilityuser.leadSource,
        lead_type_axon: "",
        Lead_Source_Detail_axon:
          apiData.findAFacilityuser.leadSourceDetail || "",
        Last_Web_Campaign__c_axon: apiData.analyticsPayload.campaign,
        Last_Web_Medium__c_axon: apiData.analyticsPayload.medium,
        Last_Web_Source__c_axon: apiData.analyticsPayload.source,
        Web_Campaign_Stacking__c_axon:
          apiData.analyticsPayload.campaignStacking,
        GACLIENTID__c_axon: apiData.analyticsPayload.gaclientid,
        GCLID__c_axon: apiData.analyticsPayload.gclid,
      })
      console.log(raw)
      const bearerToken =
        process.env.GATSBY_AXON_BEARER_TOKEN ||
        "RjYzRTMyNjhERUE5MTg1NzozMkI0RDc0QzUzRkJFNjMyMkU3RTlDMzk3QThDNA=="
      const apiBaseUrl =
        process.env.GATSBY_AXON_BASE_URL ||
        "https://pia1e7l5wi.execute-api.us-east-1.amazonaws.com/uat/welcomevisit"
      const salesforceApi = apiBaseUrl.concat("/createPatient")
      // const salesforceApi =
      //   "https://oseg5av00j.execute-api.us-east-1.amazonaws.com/test/welcomevisit/createPatient"
      console.log("processenv ", process.env.CREATEPATIENT_API)

      let result = await fetch(salesforceApi, {
        method: "POST",
        mode: "cors",
        body: raw,
        headers: {
          authorization: "Bearer " + bearerToken,
          "Content-Type": "application/json",
        },
      })
      if (result.status === 200) {
        trackFormSubmitSuccess()
        result = await result.json()
        setOpenSlotsResults(result)
        if (result.error_message === "") {
          if (result.can_book === true) {
            setShowStartSched(true)
            // fetchAxon()
            // Axon Api call for received open slot
          } else {
            setShoww(false)
            setShow(true)
          }
        } else {
          setShoww(false)
          setShow(true)
        }
      } else {
        setShoww(false)
        setErrorSales(true)
      }
    } catch (error) {
      console.log("token error is coming===============================:")
      console.log("token Error Details:", error)
    }
    // setFunction("Schedulappointment")
  }
  const myStyle = {
    backgroundImage: "url(../images/caret-down.svg)",
  }
  const fetchAxon = async () => {
    var dataresult = JSON.parse(localStorage.getItem("results"))
    console.log("dept_id", dataresult.dept_id)

    const apiBaseUrl =
      process.env.GATSBY_AXON_BASE_URL ||
      "https://pia1e7l5wi.execute-api.us-east-1.amazonaws.com/uat/welcomevisit"
    const bearerToken =
      process.env.GATSBY_AXON_BEARER_TOKEN ||
      "RjYzRTMyNjhERUE5MTg1NzozMkI0RDc0QzUzRkJFNjMyMkU3RTlDMzk3QThDNA=="

    try {
      let result = await fetch(
        apiBaseUrl.concat(
          "/openings?departmentId=",
          dataresult.dept_id,
          "&salesforceId=",
          dataresult.patient_id,
          "&insuranceName=",
          apiData.insuranceplan.insurance_name
        ),
        {
          method: "get",
          mode: "cors",
          headers: {
            authorization: "Bearer ".concat(bearerToken),
            "Content-Type": "application/json",
          },
        }
      )
      result = await result.json()
      result = convertedTimeSlots(result)
      console.log("result:", result)
      if (!result.length) {
        setShoww(false)
        setShow(true)
      } else {
        setOpenSlotsResults(result)
        setFunction("Selfschedulappointment")
      }
    } catch (error) {
      console.log("token error is coming===============================:")
      console.log("token Error Details:", error)
    }
  }
  const [showw, setShoww] = useState(false)

  const convertedTimeSlots = data => {
    const days = []
    data.forEach(item => {
      const startDate = moment(item.startDate)
      const endDate = moment(item.endDate)
      const dateStr = startDate.format("MM/DD/YYYY")

      // Only add time slot if startTime is greater or equal to 07:00
      const startTime = startDate.format("HH:mm")
      if (moment(startTime, "HH:mm").isSameOrAfter(moment("07:00", "HH:mm"))) {
        if (!days[dateStr]) {
          days[dateStr] = []
        }
        days[dateStr].push({
          startTime: startTime,
          endTime: endDate.format("HH:mm"),
        })
      }
    })
    const result = Object.keys(days).map(dateStr => {
      return {
        date: dateStr,
        time: days[dateStr],
      }
    })
    return result
  }

  if (showStartSched === true) {
    return <StartScheduling onSubmit={fetchAxon} />
  }
  return (
    <>
      <Layout>
        <section className="progress-bar-section">
          <div className="progress-bar-wrapper">
            <ProgressBar activeStep={3} />
          </div>
        </section>
        <MorningApptBanner />
        <section className="patient-information-section">
          <div className="container">
            <div className="patient-heading">
              <h4> Insurance information </h4>
            </div>
            <form className="patient-formSection">
              <div className="patient-wrapper">
                <div className="error-text">
                  {errorSales && (
                    <h5>
                      There was an error saving your information. Please try
                      again, or call us directly at 888-885-5068.
                    </h5>
                  )}
                </div>
                <div className="row align-items-center">
                  <div className="col-md-9">
                    <h4>Select Plan Coverage</h4>
                  </div>
                </div>
                <div className="patient-form-wrapper checkinSection">
                  <div className="">
                    <div className="d-flex justify-content-between">
                      <div className="form-check ctm-check">
                        <input
                          className="form-check-input"
                          id="defaultCheck1"
                          name="ppo"
                          onClick={() => setFunction("PPO")}
                          type="radio"
                          value="ppo"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="defaultCheck1"
                        >
                          PPO
                        </label>
                      </div>
                      <div className="form-check ctm-check">
                        <input
                          className="form-check-input"
                          id="defaultCheck2"
                          name="ppo"
                          onClick={() => setFunction("HMO")}
                          type="radio"
                          value="hmo"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="defaultCheck2"
                        >
                          HMO
                        </label>
                      </div>
                      <div className="form-check ctm-check">
                        <input
                          className="form-check-input"
                          defaultChecked
                          id="defaultCheck3"
                          name="ppo"
                          onClick={() => setFunction("Self-Pay")}
                          type="radio"
                          value="self_pay"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="defaultCheck3"
                        >
                          Self-Pay
                        </label>
                      </div>
                      <div className="form-check ctm-check">
                        <input
                          className="form-check-input"
                          id="defaultCheck4"
                          name="ppo"
                          onClick={() => setFunction("Not Sure")}
                          type="radio"
                          value="not_sure"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="defaultCheck4"
                        >
                          Not Sure
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="patient-form-wrapper">
                  <div className="pat-form-heading">
                    <h4>
                      {" "}
                      Insurance Details
                      <span className="hmo-tooltip">
                        Why do we need this information?
                        <div className="ctm-tooltip">
                          <div className="tooltip-header">
                            <h6>
                              <span>
                                <i className="fa-solid fa-question"></i>
                              </span>
                              Why do we need this information?
                            </h6>
                          </div>
                          <div className="tooltip-content">
                            <p>
                              We use this to check benefits eligibility. A
                              member of our enrollment team will review results
                              and coverage options with you.
                            </p>
                          </div>
                        </div>
                      </span>
                    </h4>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-12 form-group">
                      <label className="label" htmlFor="member_number">
                        Insurance Member Number<span>Optional</span>
                      </label>
                      <input
                        className="form-control"
                        id="member_number"
                        name="member_number"
                        onChange={handleChange}
                        pattern="^[a-zA-Z\s]+$"
                        placeholder="E.g - 392812820910111"
                        type="text"
                        value={user.member_number}
                      />
                    </div>
                    <div className="col-md-12 form-group">
                      <label className="label" htmlFor="member_number">
                        Insurance Group Number<span>Optional</span>
                      </label>
                      <input
                        className="form-control"
                        id="group_number"
                        name="group_number"
                        onChange={handleChange}
                        pattern="^[a-zA-Z\s]+$"
                        placeholder="E.g - 392812820910111"
                        type="text"
                        value={user.group_number}
                      />
                    </div>
                    <div className="col-md-12 form-group">
                      <label className="label" htmlFor="insurance_name">
                        Insurance Name<span>Optional</span>
                      </label>
                      <InsuranceOptionDropdown
                        apiData={apiData}
                        onChange={handleChange}
                        style={myStyle}
                        value={user.insurance_name}
                      />
                    </div>
                    <div className="col-md-12 form-group">
                      <label className="label" htmlFor="plan_name">
                        Plan Name<span>Optional</span>
                      </label>
                      <input
                        className="form-control"
                        id="plan_name"
                        maxLength={50}
                        name="plan_name"
                        onChange={handleChange}
                        pattern="^[a-zA-Z\s]+$"
                        placeholder="E.g - Gold PPO Plan"
                        type="text"
                        value={user.plan_name}
                      />
                      {!user.plan_name && (
                        <span style={{ color: "red" }}>
                          {" "}
                          {errField.plan_nameErr}
                        </span>
                      )}
                      {user.plan_name.length === 50 && (
                        <span className="input-error">
                          {" "}
                          {errField.plan_nameErr}
                        </span>
                      )}
                    </div>
                    <div className="col-md-12 form-group">
                      <label className="label" htmlFor="insurance_phone">
                        Plan Contact Number<span>Optional</span>
                      </label>
                      <input
                        className="form-control"
                        id="insurance_phone"
                        name="insurance_phone"
                        onChange={handleChange}
                        pattern="^[a-zA-Z\s]+$"
                        placeholder="E.g +1(888) 383 - 2333"
                        type="text"
                        value={user.insurance_phone}
                      />
                    </div>
                    <InsuranceEligibilty />
                  </div>
                </div>
                <div className="btn-wrapper mt-4">
                  <button
                    className="btn btnclose"
                    onClick={prevStep}
                    type="button"
                  >
                    Go Back
                  </button>
                  <ContinueButton onClick={apiCall}>Next Step</ContinueButton>
                </div>
                <div className="btn-wrapper mt-4 text-end"></div>
              </div>
            </form>
          </div>
        </section>
        <Modal className="ctm-modal ctm-modal-blue" show={show}>
          <div className="modal-header">
            <h5 className="modal-title">
              <img alt="" className="img-fluid" src={image1} />
            </h5>
            <span
              className="close-img"
              onClick={handleSubmit}
              role="button"
              tabIndex={0}
            >
              <img alt="" className="img-fluid" src={close} />
            </span>
          </div>
          <div className="modal-body">
            <div className="section-heading">
              <center>
                {" "}
                <h5>Thank You!</h5>
              </center>
            </div>
            <div className="content">
              <p>
                An enrollment specialist will contact you soon to assist with
                next steps. In the meantime, if you have a question please
                contact us at (888) 885-5068.
              </p>
            </div>
          </div>
          <div className="btn-wrap text-center mb-4">
            <button className="btn btn-blue" onClick={handleSubmit} to="/">
              Back to Website
            </button>
          </div>
        </Modal>
      </Layout>
      {showw && (
        <div className="loader">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="img-wrapper">
                  <img alt="Logo" className="img-fluid" src={LogoGreen} />
                </div>
                <div className="content">
                  <h5 className="save-title">Saving...</h5>
                  <p className="save-content">We are creating your account!</p>
                </div>
                <div className="ctm-progress">
                  <div className="progress-count">
                    <div className="spinner"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
SelfPlay.propTypes = {
  apiData: PropTypes.object.isRequired,
  prevStep: PropTypes.func.isRequired,
  setFunction: PropTypes.func.isRequired,
  setOpenSlotsResults: PropTypes.func.isRequired,
  setUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}
export default SelfPlay
